import { Intent } from '@blueprintjs/core';

export interface GenericPropertiesFieldValidation {
  inputIntent: Intent;
  inputTooltip: string;
}

export interface GenericPropertiesRowValidation {
  actionIntent: Intent;
  actionTooltip: string;
  disableAction: boolean;
  name?: GenericPropertiesFieldValidation;
  value?: GenericPropertiesFieldValidation;
}

export type GenericPropertiesValidator = (
  isNewRow: boolean,
  name: string,
  value: string
) => GenericPropertiesRowValidation;

export interface GenericProperty {
  key: string;
  name: string;
  value: string;
}

export enum GenericPropertySuggestionType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  BOOLEAN = 'BOOLEAN',
}

export interface GenericPropertySuggestion {
  name: string;
  description?: string;
  defaultValue?: string;
  type: GenericPropertySuggestionType;
}
